import React from 'react'
import DatePicker from 'react-datepicker'

import style from './style.module.scss'

function DateInput(props) {
  const { name, value, onChange, minDate } = props

  function handleChange(value) {
    onChange({ name, value })
  }

  return (
    <DatePicker
      selected={value}
      onChange={handleChange}
      className={style.wrapper}
      minDate={minDate}
    />
  )
}

export default DateInput
